import { CommonService } from '../../../common/common.service';
import { LocalStorageKey } from 'src/app/enums/local-storage-key.enum';
import { AudioService } from '../../audio.service';
import { Microphone } from 'src/app/data-models/audio/microphone.model';
import { LoggerService } from '../../../logger/logger.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
	providedIn: 'root',
})
export class MicrophoneCapabilityService {

	constructor(
		private commonService: CommonService,
		private audioService: AudioService,
		private logger: LoggerService
	) { }

	public async get(): Promise<boolean> {
		return new Promise<boolean>(resolve => {
			const notifyGetCapability: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(undefined);
			this.getMicrophoneSettings(notifyGetCapability);
			notifyGetCapability.subscribe(capability => {
				if (capability !== undefined) {
					resolve(capability);
					notifyGetCapability.unsubscribe();
				}
			});
		});
	}

	public updateCache(properties: Microphone, modes: string[]) {
		this.logger.info('ready to update microphone cache');
		this.commonService.setLocalStorageValue(LocalStorageKey.MicrophoneCapability, {
			data: properties,
			modes: modes,
		});
	}

	private getMicrophoneSettings(notifyGetCapability: BehaviorSubject<boolean>): Promise<boolean> {
		return this.audioService.getMicrophoneSettingsAsync((settings: any) => {
			if (settings.hasOwnProperty('available')) {
				this.notifyChanges(settings.available);
				notifyGetCapability.next(settings.available);
			}
		});
	}

	private async notifyChanges(capability: boolean) {
		const cache = await this.getCache();
		const cachedCapability = cache?.data?.available;
		if (cachedCapability === undefined) { return }
		if (capability !== cachedCapability) {
			cache.data.available = capability;
			this.updateCache(cache.data, cache.modes);
			this.commonService.sendNotification(LocalStorageKey.MicrophoneCapability, capability);
		}
	}

	private getCache(): any {
		return this.commonService.getLocalStorageValue(
			LocalStorageKey.MicrophoneCapability,
			undefined
		);
	}
}
